import { Controller } from "@hotwired/stimulus";
import Honeybadger from "@honeybadger-io/js";
import ahoy from "ahoy.js";

export default class extends Controller {
  static targets = ["waiting", "installed", "button"];

  connect() {
    const pollInterval = parseInt(this.element.dataset.pollInterval) || 5000;
    const checkStatus = function (interval) {
      if (this.element.dataset.installed === "true") return;

      const fetchOpts = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      this.currentTimeout = setTimeout(() => {
        fetch(this.element.dataset.checkStatusUrl, fetchOpts)
          .then((response) =>
            response.ok
              ? response.json()
              : Promise.reject(new Error(response.statusText)),
          )
          .then((data) => {
            if (data.installed) {
              console.debug("Installed!");
              this.displayInstalled(data);
            } else {
              console.debug(`Still waiting interval=${pollInterval}`);
              checkStatus(pollInterval);
            }
          })
          .catch((error) => {
            Honeybadger.notify(error);
            console.error(
              `Unable to fetch install status: ${error.message}`,
              error,
            );
            checkStatus(10000);
          });
      }, interval);
    }.bind(this);

    console.debug(`Connecting interval=${pollInterval}`);
    checkStatus();
  }

  disconnect() {
    console.debug(`Disconnecting timeout=${this.currentTimeout}`);
    clearTimeout(this.currentTimeout);
  }

  displayInstalled(statusData) {
    this.element.dataset.installed = "true";
    this.installedTargets.forEach((element) =>
      element.classList.remove("d-none"),
    );
    this.waitingTargets.forEach((element) => element.classList.add("d-none"));
    this.buttonTarget.href = statusData.error_url;
    this.buttonTarget.textContent = "View error report";
    ahoy.track("Project install completed", statusData);
  }
}
